import React, { useContext, useEffect, useState } from 'react';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext, NavRoutes } from '../../contexts';
import { ComuniContext, ComuniProvider } from './ComuniContext';
import { ComuniList, EditDialog, ImportDialog } from './components';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        navigateTo,
    } = useContext(NavContext);

    const {

        isLoadingComuni,
        getComuniAsync,

        isAutoImportingComuni,
        autoImportComuniAsync,

        isImportingComuni,
        importComuniAsync,

        isLoadingRegioni,
        getRegioniAsync,

        isLoadingProvince,
        getProvinceAsync,

        isLoadingEditProvince,
        getEditProvinceAsync,

        isUpdatingComuni,
        updateComuniAsync,

        isAutoImportingCAP,
        autoImportCAPAsync,

        isImportingCAP,
        importCAPAsync,

    } = useContext(ComuniContext)

    const loadMoreHandler = async (pageIndex, pageSize, searchText, provinciaId, regioneId, valid, orphans, notANPR, date, noCAP) => {
        await getComuniAsync(pageIndex, pageSize, searchText, provinciaId, regioneId, valid, orphans, notANPR, date, noCAP);
    }

    const [isLoading, setIsLoading] = useState(isLoadingComuni || isImportingComuni);
    useEffect(() => {
        setIsLoading(isLoadingComuni || isImportingComuni)
    }, [isLoadingComuni, isImportingComuni])

    const [openEditDialog, setOpenEditDialog] = React.useState(false);
    const [openEditCAPDialog, setOpenEditCAPDialog] = React.useState(false);
    const [openImportDialog, setOpenImportDialog] = React.useState(false);
    const [openImportCAPDialog, setOpenImportCAPDialog] = React.useState(false);

    const [searchText, setSearchText] = useState("");
    const searchClickHandler = async (searchText) => {
        setSearchText(searchText);
    };

    const comuniListActionClickHandler = async (action, data) => {
        switch (action) {
            case "Edit":
                setOpenEditDialog(true);
                break;
            case "Import":
                setOpenImportDialog(true);
                break;
            case "ImportCAP":
                setOpenImportCAPDialog(true)
                break;
            case "Add":
                window.open(NavRoutes.ComuneAdd, "_blank").focus();
                break;
            default:
                break;
        }
    }

    const editDialogActionClickHandler = async (action, data) => {
        switch (action) {
            case "Update":
                setOpenEditDialog(false);
                await updateComuniAsync(data);
                break;
            default:
                break;
        }
    }

    const importDialogActionClickHandler = async (action, data) => {
        switch (action) {
            case "Upload":
                setOpenImportDialog(false);
                await importComuniAsync(data);
                getComuniAsync(0, 25, searchText);
                break;
            case "AutoUpload":
                setOpenImportDialog(false);
                await autoImportComuniAsync();
                getComuniAsync(0, 25, searchText);
                break;
            default:
                break;
        }
    }

    const importCAPDialogActionClickHandler = async (action, data) => {
        switch (action) {
            case "Upload":
                setOpenImportCAPDialog(false);
                await importCAPAsync(data);
                getComuniAsync(0, 25, searchText);
                break;
            case "AutoUpload":
                setOpenImportCAPDialog(false);
                await autoImportCAPAsync();
                getComuniAsync(0, 25, searchText);
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const orphans = queryParams.get('orphans');
        if (user) {
            addBreadcrumbToken("Comuni");
            getComuniAsync(0, 25, null, null, null, true, orphans);
            getProvinceAsync();
            getEditProvinceAsync();
            getRegioniAsync();
        }
    }, [user]);

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid item xs={12}>
                    <PageHeader
                        disabled={isLoading}
                        onSearchClick={searchClickHandler}
                        search
                        title="Comuni"
                        subtitle="Gestisci i comuni" />
                </Grid>
                <Grid item xs={12}>
                    <ComuniList
                        searchText={searchText}
                        itemsPerPage={25}
                        onLoadMore={loadMoreHandler}
                        disabled={isLoading}
                        onActionClick={comuniListActionClickHandler} />
                </Grid>
            </Container>
            <ImportDialog
                title={"IMPORTAZIONE COMUNI"}
                open={openImportDialog}
                setOpen={setOpenImportDialog}
                onActionClick={importDialogActionClickHandler}
                disabled={isLoading} />
            <ImportDialog
                title={"IMPORTAZIONE CAP"}
                open={openImportCAPDialog}
                setOpen={setOpenImportCAPDialog}
                onActionClick={importCAPDialogActionClickHandler}
                disabled={isLoading} />
            <EditDialog
                open={openEditDialog}
                setOpen={setOpenEditDialog}
                onActionClick={editDialogActionClickHandler}
                disabled={isLoading}
            />
        </>
    );
}

export const ComuniPage = () => {

    return (
        <ComuniProvider>
            <PageContent />
        </ComuniProvider>
    );
}